<template>
    <div class="tieba-rank-wrapper">
        <div class="left" @click="goRank('rankClick')">
            <img
                :src="rankEntryInfo.rank_icon"
                class="left-icon"
            >
            <div class="middle-info">
                <span class="top">{{ rankEntryInfo.rank_name }}</span>
                <span class="bottom">
                    <span
                        class="desc"
                        :class="{'max-desc': !rankEntryInfo.has_rank}"
                    >
                        {{ rankEntryInfo.rank_desc }}
                    </span>
                    <span
                        v-if="rankEntryInfo.has_rank"
                        class="num"
                    >
                        No.{{ rankEntryInfo.rank_num }}
                    </span>
                    <i class="right-icon"></i>
                </span>
            </div>
        </div>
        <div class="right" @click="handleRightBtn">
            <span class="text">{{ rankEntryInfo.btn_text }}</span>
            <img src="https://fenwan.cdn.bcebos.com/cms/gamenow/webgame/2023-2/1675668674954/3a807ec19220.gif" class="ani">
            <i class="right-icon"></i>
        </div>
    </div>
</template>

<script>
import tbNAPI from '@baidu/tb-napi';
import {generateToken} from '@/utils/tiebaUtility';
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {getQueryString} from '@/utils/url';

export default {
    props: {
        rankEntryInfo: {
            type: Object,
            default: () => {},
        },
        gameInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isTiebaApp: false,
        };
    },
    computed: {
        pblog() {
            const {appId, appName} = this.gameInfo;
            return JSON.stringify({
                gameName: appName,
                gameId: appId,
                moduleName: 'tieba-rank-entry',
                sid: getQueryString('sid') || '',
                srcId: getQueryString('srcid') || '',
                channelid: getQueryString('channelid') || '',
            });
        },
    },
    mounted() {
        this.isTiebaApp = tbNAPI.env.isTBAPP;
        this.showLog();
    },
    methods: {
        showLog() {
            const {appId, appName, appType} = this.gameInfo;
            const {tab_id, tag_id, has_rank} = this.rankEntryInfo;
            this.$logger.display({
                value: 'entranceDisplay',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: {
                                gameName: appName,
                                gameId: appId,
                                gameType: appType,
                                module: has_rank ? 'rankedEntrance' : 'nonRankedEntrance',
                                primaryTab: tab_id,
                                secondaryTab: tag_id,
                                sid: getQueryString('sid') || '',
                                srcId: getQueryString('srcid') || '',
                                channelid: getQueryString('channelid') || '',
                            },
                            pos: '',
                        },
                    ],
                },
            });
        },
        // 前往榜单页面
        goRank(type) {
            const {appId, appName, appType} = this.gameInfo;
            const {tab_id, tag_id, has_rank, rank_url} = this.rankEntryInfo;
            this.$root.sendLog('click', type, {
                gameId: appId,
                gameName: appName,
                gameType: appType,
                primaryTab: tab_id,
                secondaryTab: tag_id,
                module: has_rank ? 'rankedEntrance' : 'nonRankedEntrance',
            });
            setTimeout(() => {
                window.location.href = rank_url;
            }, 100);
        },
        // 获取token
        getToken(url) {
            const config = {
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_mfl',
                    track: 'test',
                    url,
                },
            };
            return generateToken(config);
        },
        // 调起贴吧App
        wakeUpTiebaApp(token, pageUrl, pkgUrl) {
            TiebaNewWakeUp.init({
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_mfl',
                    token: token,
                    url: encodeURIComponent(pageUrl),
                },
                androidDownUrl: pkgUrl,
            });
        },
        // 右侧按钮点击
        handleRightBtn() {
            if (this.isTiebaApp) {
                this.goRank('lotteryBtnClick');
                return;
            }

            const {rank_url, btn_action, tieba_download_url, tab_id, tag_id, has_rank} = this.rankEntryInfo;
            const {appId, appName, appType} = this.gameInfo;
            const token = this.getToken(rank_url);
            this.$root.sendLog('click', 'lotteryBtnClick', {
                gameId: appId,
                gameName: appName,
                gameType: appType,
                primaryTab: tab_id,
                secondaryTab: tag_id,
                module: has_rank ? 'rankedEntrance' : 'nonRankedEntrance',
            });
            this.$root.report(token).then(() => {
                if (+btn_action === 2) { // 调起贴吧
                    this.wakeUpTiebaApp(token, rank_url, tieba_download_url);
                }
                else { // 进入下载中间页
                    window.location.href = this.$root.middlePage;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.tieba-rank-wrapper{
    width: 1140px;
    height: 177px;
    display: flex;
    box-sizing: border-box;
    padding: 36px;
    background-color: #F8F8F8;
    border-radius: 27px;
    margin: 45px auto 0;
    align-items: center;
    justify-content: space-between;

    .left {
        display: flex;
        align-items: center;
    }

    .left-icon {
        width: 105px;
        height: 105px;
        object-fit: cover;
    }

    .middle-info {
        margin-left: 24px;
        display: flex;
        flex-direction: column;

        .top {
            font-family: PingFangSC-Medium;
            font-size: 45px;
            color: #1F1F1F;
            line-height: 45px;
            font-weight: 500;
            max-width: 500px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .bottom {
            display: flex;
            font-size: 36px;
            color: #8F8E94;
            line-height: 40px;
            margin-top: 22px;
            height: 36px;
            align-items: center;

            .desc {
                max-width: 360px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .max-desc {
                max-width: 500px;
            }

            .num {
                color: #3388FF;
                margin-left: 9px;

            }
        }
    }

    .right-icon {
        width: 30px;
        height: 30px;
        background: url('~public/assets/imgs/ic-tieba-rank-entry.png') center center/100% auto no-repeat;
    }

    .right {
        flex-shrink: 0;
        display: flex;
        align-items: center;

        .text {
            font-size: 36px;
            color: #8F8E94;
            max-width: 200px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .ani {
            width: 90px;
            height: 90px;
            margin-left: 6px;
        }
    }
}
</style>
